
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car/[handle]",
      function () {
        return require("private-next-pages/car/[handle].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/car/[handle]"])
      });
    }
  